import { useField } from 'formik';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import { Form, Label } from 'semantic-ui-react';

interface Props extends Partial<ReactDatePickerProps> {
  changeHandler?: (data: Date) => void;
}

const MyDateInput = (props: Props) => {
  const [field, meta, helpers] = useField(props.name!);

  return (
    <Form.Field error={meta.touched && !!meta.error}>
      <DatePicker
        {...field}
        {...props}
        selected={(field.value && new Date(field.value)) || null}
        onChange={(value) => {
          if (props.changeHandler) {
            props.changeHandler(value as Date);
          }
          return helpers.setValue(value);
        }}
      />
      {meta.touched && meta.error ? (
        <Label basic color='red'>
          {meta.error}
        </Label>
      ) : null}
    </Form.Field>
  );
};

export default MyDateInput;
